import React from 'react'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'
import _ from 'lodash'
import { colors } from '@styles/vars'
import { ReactComponent as CheckIcon } from '@icons/check2.svg'
import Grid from '@blocks/Grid'
import AspectRatio from '@blocks/AspectRatio'
import useSlider from '@hooks/useSlider'
import SalonParticipationSlider from './components/Slider'

function SalonParticipation({ data: participation }: Props) {
    const slider = useSlider(SalonParticipationSlider, { participation })
    
    return (
        <LazyLoad height="200px" offset={100}>
            <Grid gap="10px">
                <AspectRatio height={participation.photo.height} width={participation.photo.width}>
                    <ImageWrapper>
                        <ImageContainer src={participation.photo.url} onClick={() => slider.open()}>
                            <PaidStatus paid={participation.paid}><CheckIcon /></PaidStatus>
                        </ImageContainer>
                    </ImageWrapper>
                </AspectRatio>
                <Description>
                    <Grid gap="5px">
                        <h4>{participation.photo.title}</h4>
                        {participation.award && <h5>{participation.award.name}</h5>}
                        <small>{participation.photo.user.first_name} {participation.photo.user.last_name}, {participation.section.name}</small>
                    </Grid>
                    {
                        (participation.votes_sum_score > 0) 
                            ? (
                                <VoteAvg>
                                    <small>Sum:</small>
                                    <p>{participation.votes_sum_score}</p>
                                </VoteAvg>
                            ) : null
                    }
                </Description>
            </Grid>
        </LazyLoad>
    )
}

export default React.memo(SalonParticipation)

// STYLES
const PaidStatus = styled.div<{ paid: boolean }>`
    position: absolute;
    top: 15px;
    right: 15px;
    width: 36px;
    height: 36px;
    background: ${colors.white};
    border-radius: 50%;
    border: 1px solid ${colors.border};
    display: ${props => props.paid ? "flex" : "none"};
    justify-content: center;
    align-items: center;
    z-index: 1;

    svg {
        width: 30px;
        height: 30px;
    }
`

const VoteAvg = styled.div`
    display: flex;
    align-items: flex-start;

    small {
        margin-right: 5px;
    }

    p {
        font-size: 36px;
        font-weight: 600;
        color: ${colors.black};
        line-height: 1;
    }
`

const Description = styled.div`
    display: flex;
    justify-content: space-between;
`

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

const ImageContainer = styled.div<{ src: string, onClick?: any }>`
    position: relative;
    width: 100%;
    height: 100%;
    background: ${({ src }) => `url(${src}) center center no-repeat`};
    background-size: cover;
    border-radius: 5px;
    cursor: ${props => props.onClick ? "zoom-in" : "auto"};
    transition: .2s ease-out;

    &:hover {
        transform: scale(1.02);
    }
`

// TYPES
type Props = ArchiveComponentProps<Admin.Resources.Participation>